<template>
  <div>
<!--    <div class="mt-1">-->
<!--      <alert-box type="danger">-->
<!--        Deposit by paypal is temporarily not available at the moment. Please contact support for help-->
<!--      </alert-box>-->
<!--    </div>-->
    <div class="card mt-5">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="pr-md-4">
              <div class="mt-md-5">
                <div>You are logging as <b>{{ user.email }}</b></div>
                <div class="mt-3">
                  Your credit balance is <b class="text-uppercase"><span> {{ credit | priceDisplay }} </span> </b><br/>
                </div>
                <div class="form-group mt-3">
                  <link-button
                      :click="() => openWithdrawModal()"
                      class="btn btn-info btn-success"
                  >
                    <i data-v-fd200a16="" class="mdi mdi-cash"></i>
                    Request Money Withdrawal
                  </link-button>
                </div>
              </div>
            </div>
          </div>
<!--          <div class="col-md-8 payment-right mt-4 pt-4 pt-md-0 mt-md-0">-->
<!--            <div class="pl-md-4">-->
<!--              <div v-if="!transaction">-->
<!--                <h3 class="page-title border-bottom pb-2">Deposit Credit</h3>-->
<!--                <div class="mt-4" style="display: inline-flex">-->
<!--                  <div-->
<!--                      style="padding: 12px;"-->
<!--                      v-for="(pkg, index) in packages"-->
<!--                      @click="() => setAmountbyType('default', pkg.amount)"-->
<!--                      :key="index"-->
<!--                      :class="{ active: pkg.amount == form.amount}"-->
<!--                  >-->
<!--                    <div style="cursor: pointer; border-radius: 4px; border: 1px solid green; padding: 12px">-->
<!--                      <i-->
<!--                          class="fa mr-2"-->
<!--                          :class="{-->
<!--                              'fa-check-circle text-success': pkg.amount == form.amount,-->
<!--                              'fa-check-circle text-muted': pkg.amount != form.amount-->
<!--                            }"-->
<!--                      />-->
<!--                      <span>Package {{ pkg.amount | priceDisplay }} </span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div style="cursor: pointer; border-radius: 4px; border: 1px solid green; padding: 12px" @click="() => setAmountbyType('custom', form.customAmount)"-->
<!--                       :class="{ active: flagCustomAmount}">-->
<!--                    <div>-->
<!--                      <i-->
<!--                          class="fa mr-2"-->
<!--                          :class="{-->
<!--                              'fa-check-circle text-success': flagCustomAmount,-->
<!--                              'fa-check-circle text-muted': !flagCustomAmount-->
<!--                            }"-->
<!--                      />-->
<!--                      <span>Custom Amount</span>-->

<!--                      <input-text-->
<!--                          type="text"-->
<!--                          class="m-0 col-md-4 mt-2"-->
<!--                          :value="form.customAmount"-->
<!--                          name="customAmount"-->
<!--                          placeholder="Custom amount (>$50)"-->
<!--                          @input="value => setField({ key: 'customAmount', value, isCustom: true })"-->
<!--                          :errors="error.customAmount"-->
<!--                      />-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <h3 class="page-title border-bottom pb-2 mb-5">Payment method</h3>-->
<!--                <div class="mb-5">-->
<!--                  <a-->
<!--                      class="d-inline-block cursor-pointer py-3 px-5 payment-logo mr-5"-->
<!--                      @click="() => setField({ key: 'paymentMethod', value: 'payoneer' })"-->
<!--                      :class="{ active: form.paymentMethod == 'payoneer' }"-->
<!--                  >-->
<!--                    <img :src="payoneerLogo" height="20"/>-->
<!--                  </a>-->
<!--                  <a-->
<!--                      class="d-inline-block cursor-pointer p-3 payment-logo mr-5"-->
<!--                      @click="() => setField({ key: 'paymentMethod', value: 'paypal' })"-->
<!--                      :class="{ active: form.paymentMethod == 'paypal' }"-->
<!--                  >-->
<!--                    <img :src="paypalLogo" height="20"/>-->
<!--                  </a>-->
<!--                  <a-->
<!--                      class="d-inline-block cursor-pointer p-3 payment-logo"-->
<!--                      @click="() => setField({ key: 'paymentMethod', value: 'lianlian' })"-->
<!--                      :class="{ active: form.paymentMethod == 'lianlian' }"-->
<!--                  >-->
<!--                    <img :src="lianlian" height="20"/>-->
<!--                  </a>-->

<!--                </div>-->
<!--                <div class="mb-5">-->
<!--                  * Use <b style="text-transform: capitalize">{{ form.paymentMethod }}</b> to save processing fee-->
<!--                </div>-->
<!--                <div class="text-right">-->
<!--                  <form-button-->
<!--                      type="success"-->
<!--                      inputType="button"-->
<!--                      :click="() => createTransaction(flagCustomAmount)"-->
<!--                      :disabled="loading"-->
<!--                      :loading="loading"-->
<!--                      text="CHECK OUT"-->
<!--                      :classes="['px-5']"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-else>-->
<!--                <div v-if="!payment_validating">-->
<!--                  <div class="mb-5">-->
<!--                    <div class="table-responsive">-->
<!--                      <table class="table table-bordered">-->
<!--                        <tbody>-->
<!--                        <tr>-->
<!--                          <td>Ref Number</td>-->
<!--                          <td class="text-right">-->
<!--                            <uuid-->
<!--                                class="text-white h4"-->
<!--                                router-name="transactionDetail"-->
<!--                                router-key="transactionId"-->
<!--                                :is-shortened="true"-->
<!--                                :id="transaction.id"-->
<!--                            />-->
<!--                          </td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td>Amount deposit</td>-->
<!--                          <td class="text-right">{{ transaction.amount | priceDisplay }}</td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td><span>Processing Fee</span></td>-->
<!--                          <td class="text-right text-muted">-->
<!--                            <span>{{ transaction.handlingFee | priceDisplay }}</span>-->
<!--                          </td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td><span>TotalPayment</span></td>-->
<!--                          <td>-->
<!--                            <h2 class="price text-right">-->
<!--                              {{ transaction.totalAmount | priceDisplay }}-->
<!--                            </h2>-->
<!--                          </td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                      </table>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div>-->
<!--                    <div id="paypal-button-container"/>-->
<!--                  </div>-->
<!--                  <div class="text-center" v-if="transaction.paymentMethod == 'paypal'">-->
<!--                    &lt;!&ndash;                    <PayPal&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :amount="transaction.totalAmount + ''"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        currency="USD"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :client="credentials"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :env="env"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :invoice-number="transaction.id"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :button-style="buttonStyle"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :experience="experienceOptions"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        :notify-url="ipnUrl"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        @payment-completed="onCompleted"&ndash;&gt;-->
<!--                    &lt;!&ndash;                        @payment-cancelled="onCancelled"&ndash;&gt;-->
<!--                    &lt;!&ndash;                    >&ndash;&gt;-->
<!--                    &lt;!&ndash;                    </PayPal>&ndash;&gt;-->
<!--                  </div>-->
<!--                  <div v-else-if="transaction.paymentMethod == 'payoneer'">-->
<!--                    <alert-box type="success">-->
<!--                      Your Deposit Order Has Been Created-->
<!--                    </alert-box>-->
<!--                    <div class="mt-5 card bg-success text-white">-->
<!--                      <div class="card-body">-->
<!--                        <p>Please send amount of <b>{{ transaction.amount | priceDisplay }}</b> to payoneer account <b>payment@wembroidery.com</b>-->
<!--                        </p>-->
<!--                        <p>Make sure to include the code <span class="badge badge-primary"><b>-->
<!--                          <uuid-->
<!--                              class="text-white h4"-->
<!--                              router-name="transactionDetail"-->
<!--                              router-key="transactionId"-->
<!--                              :is-shortened="true"-->
<!--                              :id="transaction.id"-->
<!--                          />-->
<!--                        </b></span> when transfer the money.-->
<!--                        </p>-->
<!--                        <p>The processing time could be up to 1 hour. Please contact admin <a-->
<!--                            href="mailto:payment@wembroidery.com">payment@wembroidery.com</a> if you have any problem.-->
<!--                        </p>-->
<!--                        <div class="text-right mt-5">-->
<!--                          <a class="cursor-pointer" @click="() => clearForm()">Back</a>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="text-center" v-else>-->
<!--                  <div v-if="transaction.status != 'completed'">-->
<!--                    <div class="mb-5">We are validating your transaction. Please sit tight</div>-->
<!--                    <div><i class="fa fa-spinner fa-spin fa-2x"/></div>-->
<!--                  </div>-->
<!--                  <div v-else>-->
<!--                    <alert-box type="success">-->
<!--                      Your order is successful! Have fun now!-->
<!--                    </alert-box>-->
<!--                    <div class="text-right mt-5">-->
<!--                      <a class="cursor-pointer" @click="() => clearForm()">Back</a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <modal
        :show="showPopup"
        :close="() => closeWithdrawModal()"
        title="Withdraw money">
      <div class="card-body">
        <form @submit.prevent="() => {}">
          <div class="row justify-content-md-end">
            <div class="col-md-12">
              <input-text
                  type="text"
                  :value="form.amountWithdraw"
                  label="Amount Credit"
                  placeholder="0"
                  :errors="error.amountWithdraw"
                  @input="value => { setFieldWithDraw({ key: 'amountWithdraw', value }) }"
              />
            </div>
            <div class="col-md-12">
              <input-text
                  type="text"
                  :value="form.payoneerEmailWithdraw"
                  label="Payoneer email to send to"
                  :errors="error.payoneerEmailWithdraw"
                  @input="value => { setFieldWithDraw({ key: 'payoneerEmailWithdraw', value }) }"
              />
            </div>
            <div class="col-md-12">
              <text-area
                  :value="form.note"
                  name="note"
                  label="Note"
                  @input="value => setFieldWithDraw({ key: 'note', value })"
              />
            </div>
          </div>
        </form>
      </div>
      <div slot="footer">
        <form-button
            type="primary"
            :loading="withdrawLoading"
            :click="submitWithdraw"
            text="Submit"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PayPal from 'vue-paypal-checkout';
import InputText from "@/components/Form/InputText";
import FormButton from "@/components/Form/FormButton";
import LinkButton from "@/components/Misc/LinkButton";
import TextArea from "@/components/Form/TextArea";
import AlertBox from '@/components/Misc/AlertBox';
import Uuid from '@/components/Common/Uuid';
import Modal from "@/components/Misc/Modal";

import payoneerLogo from "@/assets/images/partners/payoneer.png";
import paypalLogo from "@/assets/images/partners/paypal.svg";
import lianlian from "@/assets/images/partners/lianlian.png";


export default {
  name: "creditForm",
  components: {
    PayPal,
    InputText,
    FormButton,
    LinkButton,
    TextArea,
    AlertBox,
    Uuid,
    Modal
  },
  mounted() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=AYmwIcI_cw4abCVWSW03kwAltf0wELu6V9aepo2zi1k2XE3HtSIgfaa-JxkX7YstzuUQYCAPrWCNP7Xz`)
    document.head.appendChild(recaptchaScript)
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  data() {
    return {
      packages: [
        {amount: 50},
        {amount: 100},
        {amount: 200},
        {amount: 500},
        {amount: 1000},
      ],
      credentials: {
        sandbox: 'AYmwIcI_cw4abCVWSW03kwAltf0wELu6V9aepo2zi1k2XE3HtSIgfaa-JxkX7YstzuUQYCAPrWCNP7Xz',
        production: ''
      },
      buttonStyle: {
        label: 'checkout',
        size: 'responsive',
        shape: 'pill',
        color: 'blue',
      },
      payoneerLogo: payoneerLogo,
      paypalLogo: paypalLogo,
      lianlian: lianlian,
      flagCustomAmount: false,
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      credit: "credit/credit",
      transaction: "credit/transaction",
      loading: "credit/loading",
      payment_validating: "credit/payment_validating",
      form: "credit/form",
      showPopup: "credit/showPopup",
      withdrawLoading: "credit/withdrawLoading",
      error: 'credit/error',
    }),
    routeName() {
      return this.$router.name;
    },
    env() {
      return process.env.VUE_APP_PAYPAL_ENV === 'sandbox' ? 'sandbox' : 'production';
    },
    experienceOptions() {
      return {
        input_fields: {
          no_shipping: 1
        }
      };
    },
    ipnUrl() {
      // return 'https://147c97e4.ngrok.io/api' + '/hooks/paypal';
      return process.env.VUE_APP_API_URL + '/hooks/paypal';
    }
  },
  watch: {
    'transaction.paymentMethod': function (newVal) {
      if (newVal === 'paypal') {
        setTimeout(() => {
          console.log('xxxxxxxxxxxxxxx', paypal);
          paypal.Buttons().render('#paypal-button-container')
        }, 1000)
      }
    }
  },
  methods: {
    ...mapActions({
      setField: "credit/setField",
      setFieldWithDraw: "credit/setFieldWithDraw",
      createTransaction: "credit/createTransaction",
      beginValidateTransaction: "credit/beginValidateTransaction",
      validateTransaction: "credit/validateTransaction",
      clearForm: "credit/clearForm",
      clearError: "credit/clearError",
      openWithdrawModal: "credit/openWithdrawModal",
      closeWithdrawModal: "credit/closeWithdrawModal",
      submitWithdraw: "credit/submitWithdraw",
    }),
    onCompleted(data) {
      this.beginValidateTransaction();
      this.interval = setInterval(() => {
        if (this.transaction.status == 'completed') {
          clearInterval(this.interval);
        } else {
          this.validateTransaction();
        }
      }, 3000);
      // eslint-disable-next-line
      console.log(data);
    },
    onCancelled(data) {
      // eslint-disable-next-line
      console.log('Order canceled', data);
    },
    setAmountbyType(type, value) {
      if (type === 'custom') {
        this.flagCustomAmount = true;
      } else {
        this.flagCustomAmount = false;
        this.clearError();
      }
      this.setField({key: 'amount', value: value});
    },
  },
};
</script>

<style scoped>
/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  .payment-right {
    border-left: 1px solid #d7e7ff !important;
  }
}

@media only screen and (max-width: 991px) {
  .payment-right {
    border-top: 1px solid #d7e7ff !important;
  }
}

.table-package tr {
  border-bottom: 1px solid #d7e7ff;
  cursor: pointer;
}

.table-package tr:hover, .table-package tr.active {
  background: #eee;
  border-bottom: 1px solid #eee;
  font-weight: bold;
}

.payment-logo {
  background: #dee2e6;
  border-radius: 5px;
}

.payment-logo.active {
  background: #00c292;
}

</style>
